import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Typography,
  Grid,
  CircularProgress,
  TextField,
} from "@mui/material";

import { useMediaQuery, useTheme } from "@mui/material";

import { useSnackbar } from "notistack";

import Logo from "@assets/images/logo.png";

import { API } from "@services/API";

import QRCode from "qrcode.react";

export default function MFA() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const history = useHistory();

  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [verificationCode, setVerificationCode] = useState("");
  const [displayOTPGen, setDisplayOTPGen] = useState(true);
  const [secretKey, setSecretKey] = useState(null);
  const [otpUrl, setOtpUrl] = useState("");

  const [email, setEmail] = useState(localStorage.getItem("email"));
  const [mfaSecret, setMfaSecret] = useState(
    localStorage.getItem("mfa_secret")
  );

  useEffect(() => {
    if (!isNullOrEmpty(mfaSecret)) {
      setDisplayOTPGen(false);
      setSecretKey(mfaSecret);
    } else {
      generateSecretKey();
    }
  }, []);

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const isValidEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const generateSecretKey = () => {
    if (isNullOrEmpty(email)) {
      showSnackBar("error", "Failure", "Email can't be empty.");
    } else if (!isValidEmail(email)) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else {
      API.post(`generatekeyuri`, {
        username: email.trim(),
      })
        .then((response) => {
          setOtpUrl(response.data.keyUri);
          setSecretKey(response.data.secret);
        })
        .catch((error) => {
          showSnackBar("error", "Failure", "Internal server error.");
        });
    }
  };

  const handleOTP = (event) => {
    event.preventDefault();

    if (isNullOrEmpty(email)) {
      showSnackBar("error", "Failure", "Email can't be empty.");
    } else if (!isValidEmail(email)) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else if (isNullOrEmpty(secretKey)) {
      showSnackBar("error", "Failure", "Secret key can't be empty.");
    } else if (isNullOrEmpty(verificationCode)) {
      showSnackBar("error", "Failure", "QR code  can't be empty.");
    } else {
      setLoading(true);

      API.post(`validatecode`, {
        username: email.trim(),
        secret: secretKey.trim(),
        code: verificationCode.trim(),
      })
        .then((response) => {
          if (response.data.isValid) {
            localStorage.setItem("mfa_token", true);
            history.push("/home");
          } else {
            setLoading(false);

            showSnackBar(
              "error",
              "Failure",
              "Use Google Authenticator to Generate a New Code and Retry."
            );
          }
        })
        .catch(() => {
          setLoading(false);
          showSnackBar("error", "Failure", "Internal server error.");
        });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "85vh",
      }}
    >
      <Grid
        container
        spacing={2}
        style={{ width: isSmallScreen ? "90%" : "500px" }}
      >
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img src={Logo} alt="logo" height="100px" />
        </Grid>

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Typography
            variant="h3"
            color={"primary"}
            style={{ fontWeight: "bold" }}
          >
            Administration Portal
          </Typography>
        </Grid>

        {displayOTPGen ? (
          <>
            <Grid item xs={12}>
              <Typography>
                Multi Factor Authentication needs to be setup to access the
                portal, download Google Authenticator on your mobile phone
              </Typography>
            </Grid>

            {otpUrl && (
              <>
                <Grid item xs={12}>
                  <Typography>
                    Scan the QR code below using Google Authenticator, and enter
                    the generated code into the box below
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <QRCode value={otpUrl} />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    id="verificationCode"
                    label="QR Code"
                    onChange={(e) => setVerificationCode(e.target.value)}
                    value={verificationCode}
                    autoFocus={true}
                    required={true}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    type={"submit"}
                    size={"large"}
                    loading={loading}
                    disabled={loading}
                    onClick={handleOTP}
                    fullWidth
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Verify Generated One Time Password (OTP)"
                    )}
                  </Button>
                </Grid>
              </>
            )}
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography>
                To proceed enter in the one time password generated in
                authenticator for Connects.Health
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                variant="outlined"
                id="verificationCode"
                label="QR Code"
                onChange={(e) => setVerificationCode(e.target.value)}
                value={verificationCode}
                autoFocus={true}
                required={true}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                type={"submit"}
                size={"large"}
                loading={loading}
                disabled={loading}
                onClick={handleOTP}
                fullWidth
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Verify Generated One Time Password (OTP)"
                )}
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
}
